/**
 * TODO: This file will be deprecated and removed in the future.
 * This HOC will be replaced with `desktop/src/app/hooks/use-screen-width.js`.
 *
 * NOTE: This HOC is still in use in the following places and should be migrated to use the new hook:
 * - desktop/src/app/components/components.jsx
 * - desktop/src/app/components/google-publisher-tag/ad-on-pause/index.jsx
 * - desktop/src/app/components/series/kids/seasons-kids/selector.jsx
 * - desktop/src/app/containers/title/title-list.js
 */
import throttle from 'lodash.throttle'
import {
  compose,
  lifecycle,
  withHandlers,
  withState
} from 'recompose'

export const withScreenWidthWatching = compose(
  withState('screenWidth', 'setScreenWidth', window.innerWidth),
  withHandlers({
    updateScreenWidth: ({ setScreenWidth }) => throttle(() => {
      setScreenWidth(window.innerWidth)
    })
  }, 100),
  lifecycle({
    UNSAFE_componentWillMount() {
      this.props.updateScreenWidth()
    },
    componentDidMount() {
      window.addEventListener('resize', this.props.updateScreenWidth)
    },
    componentWillUnmount() {
      window.removeEventListener('resize', this.props.updateScreenWidth)
    }
  })
)
